export const isBrowser = typeof window === "undefined" ? false : true;
